// Бренд инстанса для текстов админки (счёт лояльности «Счёт {BRAND}» и т.п.).
// Значение приходит build-аргом REACT_APP_BRAND_NAME (в prod-сборках обязателен,
// см. Login.jsx); фолбэк STEMS — только для dev-сборок без бренд-переменных.
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'STEMS';
